export default __webpack_public_path__ + "static/media/Logor.b3f4384c.jpeg";